<template>
  <div class="card-container">
    <article class="blog-card">
      <img class="post-image" :src="inmueble.foto_portada" />
      <div class="article-details">       
        <h3 class="post-title">
          <template v-if="inmueble.gestion.esArriendoVenta">
            <strong>              
              $ {{inmueble.valor_canon_format }}
            </strong>
          </template>
          <template v-if="!inmueble.gestion.esArriendo" >
            <strong>
             $ {{ inmueble.valor_venta_format }}
              </strong>
          </template>
          <template v-if="inmueble.gestion.esArriendo">
            <strong>
              ${{ inmueble.valor_canon_format }}
              </strong>
          </template>          
        </h3>
        <p class="post-description">
          {{ inmueble.tipo_inmueble.nombre_singular }} {{ inmueble.gestion.nombre }}
        </p>
        <ul>
          <li v-if="inmueble.n_alcobas > 0">{{inmueble.n_alcobas}} Alcobas</li>
          <li v-if="inmueble.n_baños > 0">{{inmueble.n_baños}} Baños</li>
          <li v-if="inmueble.n_garajes">{{inmueble.n_garajes}} Garajes</li>
          <li></li>
        </ul>
        <p>
          <a  @click="onClickOpen" :href="inmueble.url.detail" target="_blank" v-if="(!inmueble.destacado) && (inmueble.url)">Ver</a>
        </p>
      </div>
    </article>
  </div>
</template>
<script lang="ts">
import { Inmueble } from '@/Modelos/Inmueble';
import {Vue,Component,Prop} from 'vue-property-decorator';
@Component
export default class CardPopup extends Vue {
    @Prop()
    private inmueble!:Inmueble;


    onClickOpen()
    {
      this.$store.dispatch("AnalyticsStore/logEvent",{
              name:'map_open_inmu',
              data: {
                category:this.inmueble.nombre
              }
      });
    }
}
</script>
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,700');

$bg: #eedfcc;
$text: #777;
$black: #121212;
$white: #fff;
$red: #e04f62;
$border: #ebebeb;
$shadow: rgba(0, 0, 0, 0.2);

@mixin transition($args...) {
  transition: $args;
}


.blog-card {
  display: flex;
  flex-direction: row;
  background: $white;
  box-shadow: 0 0.1875rem 1.5rem $shadow;
  border-radius: 0.375rem;
  place-content: stretch space-between;
  overflow: hidden;
}

.post-image {
  @include transition(opacity 0.3s ease);
  display: block;
  width: 100px;
  object-fit: cover;
}

.article-details {
  padding: 1.5rem;
  ul{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    vertical-align: middle;
    padding: 0 !important;
    list-style: none;

    li{
      font-size: 80%;
      padding: 2%;

    }
    :first-child{
      padding-left: 0 !important;
    }
    :last-child{
      padding-right: 0 !important;
    }

  }
}

.post-category {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.55rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.0625rem;
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.25rem 0;
  border-bottom: 0.125rem solid $border;
}

.post-title {
  @include transition(color 0.3s ease);
  font-size: 0.8rem;
  line-height: 1.4;
  color: $black;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}



</style>